<template>
  <div>
    <div class="modal modal--welcomeback"
         id="confirm">
      <div class="modal__content">
        <button class="btn modal-close">
          <i class="icon-close"></i>
        </button>
        <div class="modal__footer simple-confirm-modal">
          <p>{{ getTranslations.visitor_sign_up_1_free_for }}</p>
          <a @click.prevent="doNextAction()"
             style="cursor: pointer"
             class="btn2 btn2--std btn2--large">{{ getTranslations.home_modals_confirm_confirm }}
          </a>
          <p>{{ getTranslations.visitor_sign_up_1_single_country_already_have_account }}
            <a @click.prevent="goToLogin" style="cursor:pointer">{{ getTranslations.visitor_sign_up_1_single_country_login }}</a>
          </p>
          <p>* {{ getTranslations.visitor_sign_up_1_single_country_disclaimer }}</p>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'confirm',
  created() {
    this.showModal();
  },
  methods: {
    goToLogin() {
      this.$router.push('/login');
    },
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          vm.$emit('close');
          $('#confirm').fadeOut();
        });
      });
      /* eslint-enable */
    },
    doNextAction() {
      this.$emit('confirm');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/Confirm.vue